import React from "react";
import { useNavigate } from "react-router-dom";
import { CgSpinner } from "react-icons/cg";

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  loading?: boolean;
  to?: string; // Navigation's URL
}

export function Button({ children, loading, to, onClick, ...rest }: IProps) {
  const navigate = useNavigate();

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (to) {
      if (e.ctrlKey || e.metaKey || e.button === 1) {
        window.open(to, "_blank");
        e.preventDefault();
        return;
      }
      navigate(to);
    }

    onClick?.(e);
  };

  const handleMouseDown = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (e.button === 1 && to) {
      e.preventDefault();
      window.open(to, "_blank");
    }
  };

  return (
    <button
      {...rest}
      disabled={loading}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onAuxClick={(e) => e.preventDefault()}
    >
      {loading ? <CgSpinner className="loading-icon" /> : null} {children}
    </button>
  );
}
